import moment from 'moment';

import '../../../vendor/bootstrap-datepicker/bootstrap-datepicker.min';

export function CoreDateDirective ($filter, dateParsing) {
  const _FORMATTER_REGEX = /^(\d{4})\/(\d{1,2})\/(\d{1,2})$/;
  const _PARSER_REGEX    = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;

  return {
    require: 'ngModel',
    scope  : {
      startDate: '='
    },
    link: function(scope, element, attrs, ctrl) {
      const _DATEFORMAT      = 'dd/mm/yyyy';
      const getFormattedDate = ( date ) => new Date(moment(date).utc());

      let startDate = scope.startDate
        ? getFormattedDate(scope.startDate)
        : '';

      // find the datepicker button and initialize it first
      const datePickerElm = element.prev('span')
      .datepicker({
        autoclose: true,
        format   : dateParsing.getFormat(),
        startDate: startDate,
        todayBtn : 'linked'
      })
      .on('changeDate', e => {

        // Bootstrap datepicker is returning the wrong date
        // under specific daylight savings circumstances.
        // We add one hour to accommodate for this bug.
        e.date.setTime(e.date.getTime() + 1*60*60*1000);

        const date  = e.date.getDate();
        const month = e.date.getMonth() + 1;
        const year  = e.date.getFullYear();

        element.val(
          dateParsing.getFormat()
          .replace('dd', date)
          .replace('mm', month)
          .replace('yyyy', year)
        );

        element.trigger('input');
      });

      ctrl.$parsers.push(value => {
        const blankVal = angular.isUndefined(attrs.filter)
          ? ''
          : '*';

        if (!value) {
          ctrl.$setValidity('date', true);

          return blankVal;
        }
        if (value.match(_PARSER_REGEX)) {
          ctrl.$setValidity('date', true);

          ctrl.$viewValue = value;

          ctrl.$render();

          /**
           * WS-6940: capture what the user actually typed BEFORE the day/month
           * swap below, so the parsed result can be checked back against it.
           * _PARSER_REGEX only proves the shape d/m/yyyy, never that the date
           * exists, and the day-first format puts the day in group 1 while the
           * month-first format puts it in group 2.
           **/
          const isDayFirst = !dateParsing.getFormat() || dateParsing.getFormat() === _DATEFORMAT;
          const typed      = value.match(_PARSER_REGEX);
          const typedDay   = parseInt(isDayFirst ? typed[1] : typed[2], 10);
          const typedMonth = parseInt(isDayFirst ? typed[2] : typed[1], 10);
          const typedYear  = parseInt(typed[3], 10);

          if (isDayFirst) {
            value = value.replace(_PARSER_REGEX, '$2/$1/$3');
          }

          const fullDate = getFormattedDate(value);
          const date     = fullDate.getDate();
          const month    = fullDate.getMonth() + 1;
          const year     = fullDate.getFullYear();

          /**
           * WS-6940: a shape-valid but calendar-impossible date used to be
           * accepted here, in two distinct ways, both silent:
           *
           *   32/13/2026 -> Date is Invalid, so date/month/year are all NaN and
           *     the timeless branch below built the literal string
           *     "NaN-NaN-NaN". Validity stayed true, so the field looked fine
           *     and the value was truthy, which defeated every downstream
           *     "is the date present" guard. The backend could not parse it and
           *     stored NULL. 28 customer_deposits rows in AU production carry a
           *     NULL date_received from this, a steady 2 to 8 a year since 2017,
           *     and Kathleen reproduced it on Staging as WS-6657 TC-10.
           *
           *   31/02/2026 -> Date rolls the overflow forward to 03/03/2026 and
           *     reports itself valid, so a typo is stored as a real but wrong
           *     date with nothing shown to the user. 29/02 in a non-leap year
           *     and 31/04 behave the same way.
           *
           * Comparing the parsed components back against what was typed catches
           * both: a rolled-over date disagrees on the day, and an impossible one
           * yields NaN, which fails every comparison. Rejecting through the same
           * blankVal path already used for unparseable input (for example "abc")
           * keeps the behaviour consistent: the label switches to "Invalid Date"
           * and any submit button bound to the form's validity stays disabled.
           **/
          if (date !== typedDay || month !== typedMonth || year !== typedYear) {
            ctrl.$setValidity('date', false);

            return blankVal;
          }

          if ( startDate && startDate > fullDate ) {
            ctrl.$setValidity('date', false);

            return blankVal;
          }

          if (attrs.format) {
            return $filter('date')(fullDate, attrs.format);
          }
          else if (attrs.timeless) {
            return `${ year }-${ month < 10 ? `0${ month }` : month }-${ date < 10 ? `0${ date }` : date }`;
          }
          else {
            return fullDate.toISOString();
          }
        }
        else {
          ctrl.$setValidity('date', false);
          return blankVal;
        }
      });

      ctrl.$formatters.push(value => {
        if (!value) {
          return '';
        }

        value = value.replace(/-/g, '/');

        if (value.match(_FORMATTER_REGEX)) {
          if (dateParsing.getFormat() === _DATEFORMAT) {
            return value.replace(_FORMATTER_REGEX, '$3/$2/$1');
          }
          else {
            return value.replace(_FORMATTER_REGEX, '$2/$3/$1');
          }
        }
        else {
          return '';
        }
      });

      scope.$watch('startDate', () => {
        const fullDate = ctrl.$modelValue
          ? getFormattedDate(ctrl.$modelValue)
          : '';

        if ( scope.startDate ) {
          if ( !dateParsing.getFormat() || dateParsing.getFormat() === _DATEFORMAT ) {
            scope.startDate = scope.startDate.replace(_PARSER_REGEX, '$2/$1/$3');
          }

          startDate = getFormattedDate(scope.startDate);
        }

        if ( startDate && fullDate && startDate > fullDate ) {
          ctrl.$setValidity('date', false);
        }

        datePickerElm.datepicker('setStartDate', startDate);
      });
    }
  };
}